// extracted by mini-css-extract-plugin
export var courseMaterialsTabView = "CourseMaterialsTabView-module--courseMaterialsTabView--1Kz1e";
export var courseMaterialsTabSwitcher = "CourseMaterialsTabView-module--courseMaterialsTabSwitcher--ZMVFR";